import { Modal } from 'antd'
import { addSpanToWhitespace } from 'admin/lib/Functions/whiteSpaceHelper'
import { massUpdatableFields } from 'admin/lib/GroupUpdateHelpers/massUpdateableFields'

export function UpdateRecordsSummaryModal({
  visible,
  onOk,
  onCancel,
  processing,
  submitEnabled,
  updateRecords,
  tableProps,
  updateRecordsValue
}) {
  return (
    <Modal
      open={visible}
      title="Update records summary"
      styles={{ body: { minHeight: '168px' } }}
      onOk={onOk}
      onCancel={onCancel}
      okButtonProps={{
        disabled: !submitEnabled,
        loading: processing,
        style: {
          minWidth: '130px'
        },
        type: 'danger'
      }}
      okText={processing ? 'Updating records' : 'Update records'}
      cancelButtonProps={{
        disabled: processing,
        type: 'secondary'
      }}
      cancelText="Back"
    >
      <div>
        <p className="large-text">
          You're about to update{' '}
          <b>
            {updateRecords.reduce(
              (partialSum, a) => partialSum + a.recordAndProjectIds.length,
              0
            )}
          </b>{' '}
          records.
        </p>
        <p>
          Setting:{' '}
          <b>
            {massUpdatableFields[tableProps.moduleName][tableProps.fieldName]}
          </b>
          <br />
          To: <b>{addSpanToWhitespace(updateRecordsValue)}</b>
        </p>
        <table width="100%">
          <tr>
            <th style={{ textAlign: 'left' }}>Old value</th>
            <th style={{ textAlign: 'center', width: '72px' }}>Count</th>
          </tr>

          {updateRecords.map(group => {
            return (
              <tr key={group.oldValue}>
                <td style={{ textAlign: 'left' }}>
                  {addSpanToWhitespace(group.oldValue)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  {group.recordAndProjectIds.length}
                </td>
              </tr>
            )
          })}
        </table>
      </div>
    </Modal>
  )
}
